module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Scotty McLennan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("The Rev. Scotty McLennan is the dean for religious life at Stanford University. He was the university Chaplain at Tufts University from 1984 to 2000, and senior lecturer at the Harvard Business School for ten of those years. McLennan received his B.A. from Yale University in 1970 as a Scholar of the House working in the area of computers and the mind. He received his M.Div. and J.D. degrees from Harvard Divinity and Law Schools in 1975. In 1975, he was also ordained to the ministry (Unitarian Universalist) and admitted to the Massachusetts bar as an attorney. He is the author of "), _c('I', [_vm._v("Finding Your Religion")]), _vm._v(" and was the inspiration for "), _c('I', [_vm._v("Doonesbury")]), _vm._v("'s Rev. Scott Sloan.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AfQ1yx/tc-custom/9780230621268.jpg?1742153044789",
      "alt": "This image is the cover for the book Jesus Was a Liberal"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jesus Was a Liberal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For the millions of people who identify as liberal Christians. In McLennan's bold call to reclaim ownership of Christianity, he advocates a sense of religion based not on doctrinal readings of scripture but on the humanity behind Christ's teachings. He addresses such topics as intelligent design, abortion, same sex marriage, war. torture and much, much more. As he says in the Preface, \"We liberal Christians know in our hearts that there is much more to life than seems to meet the rational eye of atheists; yet we find it hard to support supernatural claims about religion that fly in the face of scientific evidence.\"")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0